import { LOGIN, LOGOUT, UPDATE_USER } from '../mutation-types';
import axios from 'axios';
import util from '../../common/util';

const domain_tmp_arr = document.domain.split('.');
const domain_arr = [
    domain_tmp_arr[domain_tmp_arr.length - 2],
    domain_tmp_arr[domain_tmp_arr.length - 1]
];
const user_domain = '_' + domain_arr.join('_');

const user_login_status = `${user_domain}_user_login_status`;

function checkUserInOtherIframe() {
    //  If the pop-up box on the details page ,  Notify the login status of the parent window after the login status changes 
    if (util.inPopDetailPage) {
        window.parent.siteAppVm.$store.dispatch('getUser', {
            checkOtherIframe: false
        });
    } else if (window.__curDetailPop) {
        window.__curDetailPop.refreshIframUserState();
    }
}

export default {
    state: () => ({
        user: 0,
        loginStatus: 0 // 0  is the initial state ，1  yes   Log in ，-1  is log out 
    }),
    getters: {
        hasLoggedIn: state => {
            return !!state.user;
        },
        // vow email verify
        userEmailVerified: state => {
            return (
                util.getQueryField('isPopup') === '0' ||
                (state.user?.vowListingsStatus ?? false)
            );
        }
    },
    actions: {
        getUser({ commit, state, rootState }, payload) {
            let loginInfo = rootState.page?.page?.loginInfo;
            var checkOtherIframe =
                    payload.checkOtherIframe === undefined
                        ? true
                        : payload.checkOtherIframe,
                fromGlobal =
                    payload.fromGlobal === undefined
                        ? false
                        : payload.fromGlobal;
            if (
                fromGlobal &&
                !loginInfo &&
                util.getCookie(user_login_status) === '1'
            ) {
                //  if logged in ， But because of caching ， There is no login information in the global data ， Then directly call the interface to obtain 
                console.log('loginInfo', loginInfo);
                fromGlobal = false;
            }
            var ps = fromGlobal
                ? Promise.resolve(loginInfo)
                : axios
                      .post(
                          '/api-graphql',
                          {
                              query: `{loginInfo{id,account,firstName,fullName,lastName,phoneNumber,teamId,inactive,createTimeMills,firstLogin,vowListingsStatus,agreeProtocol,baseId,officeId,enterpriseRole,userState}}`
                          },
                          {
                              noCache: true
                          }
                      )
                      .then(({ data }) => {
                          return data && data.loginInfo;
                      });
            return ps
                .then(loginInfo => {
                    if (loginInfo) {
                        loginInfo.createTime = loginInfo.createTimeMills;
                        commit(LOGIN, {
                            user: loginInfo,
                            checkOtherIframe,
                            fromGetUser: true
                        });
                        return loginInfo;
                    } else {
                        commit(LOGOUT, checkOtherIframe);
                        return 0;
                    }
                })
                .catch(e => {
                    util.setCookie(user_domain + '_visitor_email', '');
                    util.setCookie(user_domain + '_visitor_name', '');
                    state.loginStatus = -1;
                    console.error('loginInfo', e);
                });
        }
    },
    mutations: {
        [LOGIN](state, { user, checkOtherIframe, fromGetUser }) {
            state.loginStatus = 1;
            state.user = user;
            if (user) {
                util.setCookie(user_domain + '_visitor_email', user.account);
                util.setCookie(user_domain + '_visitor_name', user.fullName);
                util.setCookie(user_login_status, '1');
                if (checkOtherIframe !== false) {
                    checkUserInOtherIframe();
                }
                window.siteAppVm?.$EventBus?.$emit('userLogin', user);
            }
        },
        [LOGOUT](state, checkOtherIframe) {
            state.loginStatus = -1;
            state.user = null;
            util.setCookie(user_domain + '_visitor_email', '');
            util.setCookie(user_domain + '_visitor_name', '');
            util.setCookie(user_login_status, '');

            if (checkOtherIframe !== false) {
                checkUserInOtherIframe();
            }
            //  user information cache 
            // history.replaceState(null,null,`#r${Date.now()}`);
            window.siteAppVm?.$EventBus?.$emit('userLogout');
        },
        [UPDATE_USER](state, data) {
            state.user = Object.assign({}, state.user, data);
        }
    }
};
